import React, { useEffect } from "react";

const Network = () => {
    useEffect(() => {
        window.location.href = "https://www.youtube-nocookie.com/embed/nvGnFyPB32k?playlist=nvGnFyPB32k&autoplay=1&iv_load_policy=3&loop=1&start=";
    }, []);

    return null;
};

export default Network;